import { render, staticRenderFns } from "./epocrates.vue?vue&type=template&id=44461940&scoped=true&v-once=true"
import script from "./epocrates.vue?vue&type=script&lang=js"
export * from "./epocrates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44461940",
  null
  
)

export default component.exports